import { getEditorTrackingFieldNames } from "./getEditorTrackingFields";

export default function getHiddenFields() {
  const hiddenFields = getEditorTrackingFieldNames();
  const allOthers = [
    "checklist_id",
    "Collaboration Status",
    "commentCount",
    "Created Date",
    "Creator Email",
    "equipment_id",
    "fileCount",
    "id",
    "issue_id",
    "issueCount",
    "latlon",
    "map",
    "Modified By",
    "observation_id",
    "placeId",
    "project_id",
    "Selected",
    "template_id",
    "uid",
    "equipment_id",
  ];
  const combined = [...hiddenFields, ...allOthers];

  return combined;
}
